import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { DeviceType, AppModule } from '@/store/modules/app';
import { SettingsModule } from '@/store/modules/settings';
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components';
import ResizeMixin from './mixin/resize';
let default_1 = class extends mixins(ResizeMixin) {
  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile
    };
  }
  get showSettings() {
    return SettingsModule.showSettings;
  }
  get showTagsView() {
    return SettingsModule.showTagsView;
  }
  get fixedHeader() {
    return SettingsModule.fixedHeader;
  }
  handleClickOutside() {
    AppModule.CloseSideBar(false);
  }
};
default_1 = __decorate([Component({
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Settings,
    Sidebar,
    TagsView
  }
})], default_1);
export default default_1;